import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import CurrentUserTop from './CurrentUserTop'; // Adjust the path as needed

const TopMenu = () => {
    const currentUser = useSelector((state) => state.user.data);

    console.log('Current User:', currentUser); // Debugging: Log the current user

    return (
        <Navbar bg="dark" variant="dark" expand="lg" className="px-3">
            <Navbar.Brand href="#"><img src="/logo512-1.png" alt="bint business intelligence integration b2b" height={30} /> <span style={{color:"orange"}}>B</span>usiness <span style={{color:"orange"}}>Int</span>elligence </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                    <CurrentUserTop user={currentUser} />
                    {!! currentUser && <Nav.Link href="/profile">Profil</Nav.Link> }
                    {!!currentUser
                        ? <Nav.Link href="/logout">Logout</Nav.Link>
                        : <Nav.Link href="/login">Login</Nav.Link>}
                </Nav>
            </Navbar.Collapse>
        </Navbar>

    );
};

export default TopMenu;